// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as React from "react";
import DashboardBarButton from "./DashboardBarButton";
import DashboardBarConfirmSupprimer from "./DashboardBarConfirmSupprimer";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardBarButtonSupprimer = props => {
  const {
    disabled,
    onClick
  } = props;
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const handleClick = React.useCallback(() => {
    setLoading(true);
    setOpen(true);
  }, []);
  const handleConfirm = React.useCallback(() => {
    if (onClick) {
      onClick();
    }
    setOpen(false);
    setLoading(false);
  }, [onClick]);
  const handleCancel = React.useCallback(() => {
    setOpen(false);
    setLoading(false);
  }, []);
  const confirmDeleting = React.useMemo(() => /*#__PURE__*/_jsx(DashboardBarConfirmSupprimer, {
    header: "Suppression",
    content: "Êtes-vous sûr de vouloir supprimer ce tableau de bord ?",
    open: open,
    onCancel: handleCancel,
    onConfirm: handleConfirm
  }), [open, handleCancel, handleConfirm]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DashboardBarButton, {
      icon: "trash",
      label: "Supprimer",
      disabled: disabled,
      loading: loading,
      onClick: handleClick,
      "data-sentry-element": "DashboardBarButton",
      "data-sentry-source-file": "DashboardBarButtonSupprimer.tsx"
    }), confirmDeleting]
  });
};
export default DashboardBarButtonSupprimer;